import { render } from "./SuccessMsg.vue?vue&type=template&id=76cd39f7&scoped=true"
import script from "./SuccessMsg.vue?vue&type=script&lang=js"
export * from "./SuccessMsg.vue?vue&type=script&lang=js"

import "./SuccessMsg.vue?vue&type=style&index=0&id=76cd39f7&scoped=true&lang=css"

import exportComponent from "/builds/ct-dev/clickcease/google-health-report-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76cd39f7"]])

export default __exports__